import { useState, useEffect } from 'react'
import { LocationStateHook } from '../types/validationTypes'

export const useLocationState = (absenceReasonType?: string): LocationStateHook => {
  const [location, setLocation] = useState<boolean>(false)

  useEffect(() => {
    if (window.location.pathname.includes('myavailability')) {
      setLocation(false)
    } else {
      setLocation(true)
    }
  }, [absenceReasonType])

  return {
    location,
    setLocation,
  }
}
